module.exports = "img/flags/AM.4ea6eb5.png";